import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolean'
})
export class BooleanPipe implements PipeTransform {

  transform(value: any, label:any = {_true:"Sim", _false:"Não"}): any {
    if(value){
      return label._true;
    }
    return label._false;
  }

}
